export default "__VITE_ASSET__CzGasFOg__"